import variables from '@/assets/styles/element-variables.scss'

const state = {
  theme: localStorage.getItem("lyods-theme") || variables.theme,
  showSettings: false,
  tagsView: true,
  fixedHeader: "true" == localStorage.getItem("lyods-fixedHeader"),
  sidebarLogo: true
}

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  }
}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/settings.js